<template>
  <div class="share-wrapper">
    <FixturesScreenshot type="handicap">
      <div class="share-container">
        <!-- HEADER BLUE SECTION -->
        <div class="header">
          <!-- Decorative Icons -->
          <div class="decorative-icons">
            <div class="icon icon-1">⚽</div>
            <div class="icon icon-2">🎯</div>
            <div class="icon icon-3">💰</div>
            <div class="icon icon-4">✨</div>
          </div>

          <!-- Logo and Title -->
          <div class="header-content">
            <div class="logo-container">
              <img src="@/assets/img/bxb.png" class="header-logo" />
            </div>

            <h1 class="header-title">
              {{ bet.title }}
            </h1>

            <!-- Glassmorphism Match Info -->
            <div class="match-info">
              <!-- Teams -->
              <div class="teams-info">
                <div class="team-name">
                  {{ bet.homeTeam }}
                  <span
                    v-if="bet.predictionType === 'body' && bet.isHomeTeamUpper"
                    class="handicap"
                  >
                    ({{ oddsInfi(bet.handicapValue, bet.handicapPrice) }})
                  </span>
                </div>
                <div class="vs-text">VS</div>
                <div class="team-name">
                  {{ bet.awayTeam }}
                  <span
                    v-if="bet.predictionType === 'body' && !bet.isHomeTeamUpper"
                    class="handicap"
                  >
                    ({{ oddsInfi(bet.handicapValue, bet.handicapPrice) }})
                  </span>
                </div>
              </div>

              <!-- Score Box -->
              <div class="score-box">
                <div class="score">{{ bet.score }}</div>
              </div>

              <!-- Prediction Badge -->
              <div
                v-if="bet.predictionType === 'goal_total'"
                class="prediction-badge"
              >
                (G - Total)&nbsp;
                <span class="prediction-odds">
                  {{ oddsInfi(bet.handicapValue, bet.handicapPrice) }}
                </span>
              </div>
            </div>

            <!-- Yellow Return Box -->
            <div v-if="bet.status !== 'lose'" class="yellow-box">
              <p class="yellow-label">ပြန်ရငွေ</p>
              <p class="yellow-amount">
                {{ formatNumber(bet.returnedCoin ?? 0) }} Ks
              </p>
            </div>

            <p class="header-description">{{ bet.body }}</p>
          </div>
        </div>

        <!-- WHITE SECTION - BET DETAILS -->
        <div class="bet-details">
          <div class="bet-details-container">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <circle cx="12" cy="12" r="6"></circle>
              <circle cx="12" cy="12" r="2"></circle>
            </svg>
            <h3 class="details-title">လောင်းငွေအသေးစိတ်</h3>
          </div>

          <div class="details-container">
            <div class="detail-row">
              <span class="detail-label">လောင်းငွေ</span>
              <span class="detail-value"
                >{{ formatNumber(bet.predictedCoin ?? 0) }} Ks</span
              >
            </div>
            <div class="detail-divider"></div>
            <div class="detail-row">
              <span class="detail-label">ရွေးချယ်မှု</span>
              <span class="detail-value prediction">{{
                bet.predictionSide
              }}</span>
            </div>
            <div class="detail-divider"></div>
            <div class="detail-row">
              <span class="detail-label">ရငွေ</span>
              <span class="detail-value return"
                >{{ formatNumber(bet.returnedCoin) }} Ks</span
              >
            </div>
            <div class="detail-divider thick"></div>
            <div class="detail-row">
              <span class="detail-label bold">{{
                isWin ? "အမြတ်" : "အရှုံး"
              }}</span>
              <span class="detail-value win-lose" :class="winLoseColor">
                {{ bet.winOrLoseCoin > 0 ? "+" : ""
                }}{{ formatNumber(bet.winOrLoseCoin) }} Ks
              </span>
            </div>
          </div>
        </div>

        <!-- ROI / RESULT SECTION -->
        <div v-if="bet.status !== 'lose'" class="roi-result">
          <div class="roi-result-container">
            <div class="roi-box">
              <div class="roi-label">
                <div class="icon-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                    <polyline points="16 7 22 7 22 13"></polyline>
                  </svg>
                </div>
                <span>ROI</span>
              </div>
              <div class="roi-value" :class="roiColor">{{ bet.roi }}</div>
            </div>

            <div class="result-divider"></div>

            <div class="result-box">
              <div class="result-label">
                <div class="icon-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <circle cx="12" cy="12" r="6"></circle>
                    <circle cx="12" cy="12" r="2"></circle>
                  </svg>
                </div>
                <span>Result</span>
              </div>
              <div class="result-value" :class="statusColor">
                {{ bet.status }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </FixturesScreenshot>
  </div>
</template>

<script>
import FixturesScreenshot from "@/components/FixturesScreenshot.vue";
import format from "../../utils/format.js";
import { mapActions } from "vuex";

export default {
  name: "HandicapShareSection",
  components: {
    FixturesScreenshot,
  },
  data() {
    return {
      bet: {},
    };
  },
  computed: {
    isWin() {
      return (
        this.bet.status === "ပြားနိုင်" || this.bet.status === "အပြည့်နိုင်"
      );
    },
    isLose() {
      return this.bet.status === "lose" || this.bet.status === "ပြားရှုံး";
    },
    statusColor() {
      if (this.isWin) return "win";
      if (this.isLose) return "lose";
      return "pending";
    },
    roiColor() {
      if (this.isWin) return "win";
      if (this.isLose) return "lose";
      return "pending";
    },
    winLoseColor() {
      if (this.isWin) return "win";
      if (this.isLose) return "lose";
      return "pending";
    },
  },
  methods: {
    ...mapActions({
      getShareData: "getShareData",
    }),
    oddsInfi(value, price) {
      return `${value > 0 ? "+" : ""}${value}/${price}`;
    },
    formatNumber(number) {
      if (number == null || isNaN(number)) return "0";
      return new Intl.NumberFormat("en-US").format(number);
    },
    isWin(fixture) {
      return fixture.status === "full_win" || fixture.status === "partial_win";
    },
    async getShare() {
      let option = {
        id: this.requestId,
      };
      await this.getShareData({ ...option }).then((res) => {
        this.bet = res.data;
      });
    },
  },
  async mounted() {
    this.requestId = this.$route.query.id;
    this.getShare();
  },
};
</script>

<style scoped>
.share-wrapper {
  width: 420px;
  margin: auto;
  background: #fff;
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

/* HEADER BLUE SECTION */
.header {
  position: relative;
  background: linear-gradient(160deg, #193cb9, #1e47d4, #193cb9);
  padding: 32px 20px;
  text-align: center;
  color: #fff;
  overflow: hidden;
}

/* Decorative Icons */
.decorative-icons {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.1;
  pointer-events: none;
}

.icon {
  position: absolute;
}

.icon-1 {
  top: 16px;
  left: 16px;
  font-size: 3rem;
}

.icon-2 {
  top: 32px;
  right: 32px;
  font-size: 2.5rem;
}

.icon-3 {
  bottom: 16px;
  left: 25%;
  font-size: 2rem;
}

.icon-4 {
  right: 48px;
  bottom: 32px;
  font-size: 2.5rem;
}

/* Header Content */
.header-content {
  position: relative;
  z-index: 1;
}

.logo-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  margin-bottom: 24px;
}

.header-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.header-title {
  font-size: 1.25rem;
  font-weight: 900;
  margin-bottom: 16px;
}

/* Glassmorphism Match Info */
.match-info {
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

.teams-info {
  margin-bottom: 12px;
}

.team-name {
  font-size: 1.125rem;
  font-weight: 900;
  margin-bottom: 4px;
}

.vs-text {
  font-size: 1.125rem;
  font-weight: 700;
  color: #86efac;
  margin: 4px 0;
}

.handicap {
  color: #fde047;
}

.score-box {
  background: #fff;
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.score {
  font-size: 1.875rem;
  font-weight: 900;
  color: #193cb9;
}

.prediction-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(4px);
  border-radius: 8px;
  padding: 4px 16px;
  font-size: 0.875rem;
  font-weight: 700;
}

.prediction-odds {
  color: #fde047;
}

/* Yellow Return Box */
.yellow-box {
  background: #facc15;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

.yellow-label {
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 8px;
  color: #000;
}

.yellow-amount {
  font-size: 1.875rem;
  font-weight: 900;
  color: #000;
}

.header-description {
  font-size: 1.125rem;
  font-weight: 600;
  margin-top: 16px;
}

/* WHITE SECTION - BET DETAILS */
.bet-details {
  background: linear-gradient(to bottom, #f9fafb, #fff);
  padding: 20px;
}

.bet-details-container {
  display: flex;
  align-items: center;
  width: 100%;
  height: 20px;
  margin-bottom: 10px;
}

.details-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
  padding-left: 25px;
}

.icon {
  width: 20px;
  height: 20px;
  color: #193cb9;
}

.details-container {
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  padding: 16px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}

.detail-label {
  font-size: 0.875rem;
  color: #6b7280;
}

.detail-value {
  font-weight: 700;
  color: #1f2937;
}

.detail-label.bold {
  font-weight: 700;
  color: #1f2937;
}

.detail-value.prediction {
  color: #2563eb;
}

.detail-value.return {
  color: #193cb9;
}

.detail-value.win-lose.win {
  color: #193cb9;
  font-size: 1.25rem;
}

.detail-value.win-lose.lose {
  color: #dc2626;
  font-size: 1.25rem;
}

.detail-value.win-lose.pending {
  color: #6b7280;
  font-size: 1.25rem;
}

.detail-divider {
  height: 1px;
  background: #e5e7eb;
  margin: 0 -16px;
}

.detail-divider.thick {
  height: 2px;
  background: #d1d5db;
  margin: 0 -16px;
}

/* ROI / RESULT SECTION */
.roi-result {
  padding: 0 20px 20px;
}

.roi-result-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  border: 1px solid #bfdbfe;
  border-radius: 12px;
  background: linear-gradient(to right, #eff6ff, #e0e7ff);
  padding: 16px;
}

.roi-box,
.result-box {
  text-align: center;
}

.roi-label,
.result-label {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}

.roi-label .icon {
  width: 16px;
  height: 16px;
  color: #2563eb;
}

.result-label .icon {
  width: 16px;
  height: 16px;
  color: #193cb9;
}

.roi-label span,
.result-label span {
  font-size: 0.75rem;
  font-weight: 600;
}

.roi-label span {
  color: #2563eb;
}

.result-label span {
  color: #193cb9;
}

.roi-value,
.result-value {
  font-size: 1.25rem;
  font-weight: 900;
}

.roi-value.win,
.result-value.win {
  color: #1e3a8a;
}

.roi-value.lose,
.result-value.lose {
  color: #dc2626;
}

.roi-value.pending,
.result-value.pending {
  color: #6b7280;
}

.result-divider {
  width: 1px;
  height: 48px;
  background: #bfdbfe;
  margin: 0;
}
</style>

// title: "မမှန်ခဲ့ပါ။ 😞", // body: "Strong home performance with consistent
handicap results.", // homeTeam: "Lyon", // awayTeam: "Marseille", // score: "1
- 0", // predictionType: "goal_total", // handicapValue: 3, // handicapPrice:
50, // predictedCoin: 5000, // returnedCoin: 0, // isHomeTeamUpper: false, //
predictionSide: "G - Over", // status: "win", // roi: "-100%", // winOrLoseCoin:
-5000,
